export default {
    login: '',
    logout: process.env.REACT_APP_USER_SERVICE_API + '/auth/logout',
    recoverPassword: '',
};